import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { IFilterShortcutButtonInfo } from '../../../../constants/filter/shortCut/filterShortcut.constant';
import { FilterType } from '../../../../interfaces/Filter.interfaces';

interface IFilterShortcutButtonProps extends IFilterShortcutButtonInfo {
  filterType: FilterType;
}

export const FilterShortcutButton = ({ logoUrl, navigateTo, title, filterType }: IFilterShortcutButtonProps) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(navigateTo);
    ampli.pvmClickFilterSelection({ filter_type: filterType, title });
  };

  return (
    <Container onClick={handleButtonClick}>
      <LogoWrapper>
        <Logo src={logoUrl} />
      </LogoWrapper>
      <Title>{title}</Title>
    </Container>
  );
};

const Container = styled.div`
  width: 72px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  cursor: pointer;
`;

const LogoWrapper = styled.div`
  width: 72px;
  height: 72px;

  padding: 4px;
`;

const Logo = styled.img``;

const Title = styled.div`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */

  white-space: nowrap;
`;
